export const ACCEPT = [
  'image/png',
  'image/jpeg'
];

export const MAX_SIZE = 10_000_000;

export const getAcceptString = () => ACCEPT.join(',');

const ImageValidatorsLib = {
  ACCEPT,
  MAX_SIZE,
  getAcceptString,
};
export default ImageValidatorsLib;
